import styles from "./spacer.module.css";

const Spacer = () => {
  return <div className={styles.container} />;
};

export default Spacer;
